import React, { useState } from "react";
import NetaqInput from "./NetaqInput";
import ActionButton from "./ActionButton";
import { useDispatch, useSelector } from 'react-redux';
import { resetFilter } from "../Redux/Auctions/AuctionsSlice";
import { fetchAuctions } from '../Redux/Auctions/AuctionActions';
import { useTranslate } from "./TranslationText";
import SubmitBtn from "./SubmitBtn";
import NewActionButton from "./ActionButtons/NewActionButton";
import { filterButtonsContainer, filterCard, filterHeader, filterResetBtn, filterSubmitBtn } from "../common/cssclasses";

const NewsFilter = ({ onSubmit }) => {
  const [checker, setChecker] = useState(true);
  const { translate } = useTranslate();
  const [dateStartFrom, setDateStartFrom] = useState(null);
  const [dateStartTo, setDateStartTo] = useState(null);

  const [filterState, setFilterState] = useState({
    // Initial filter values
    newsName: "",
    newscategory: "both",
    newsClassification: "both",
    DateFrom: "",
    DateTo: "",
  });

  const dispatch = useDispatch();

  const handleChange = (event, input) => {
    if (!!input && input === "DateFrom") {
      setDateStartFrom(event)
      setFilterState({
        ...filterState,
        DateFrom: event.$d.toISOString(),
      });
      return;
    }
    if (!!input && input === "DateTo") {
      setDateStartTo(event)
      setFilterState({
        ...filterState,
        DateTo: event.$d.toISOString(),
      });
      return;
    }
    const value = event.target.type == 'checkbox' ? event.target.checked : event.target.value
    setFilterState({
      ...filterState,
      [event.target.name]: value,
    });


  };

  const handleSubmit = (event) => {
    window.scrollTo(0, 0);
    event.preventDefault();
    onSubmit(filterState); // Pass filter state to News
    // dispatch(resetFilter());
    // dispatch(fetchAuctions(filterState));
  };
  const handleReset = (event) => {
    window.scrollTo(0, 0);

    setDateStartFrom(null)
    setDateStartTo(null)

    setFilterState({
      newsName: "",
      newscategory: "both",
      newsClassification: "both",
      DateFrom: "",
      DateTo: "",
    });
  };



  return (
    <form
      className={filterCard}
      onSubmit={handleSubmit}
      onReset={handleReset}
    >
      <h2 className={filterHeader}>{translate('web.advancedSearch', 'Advanced Search')}</h2>
      <div className="mb-form-group">
        <NetaqInput
          name={'newsName'}
          label={translate("web.newsTitle", "News Title")}
          key={"search"}
          placeholder={translate("web.newsTitle", "News Title")}
          type={"text"}
          onChange={handleChange}
        />
      </div>
      <div className="mb-form-group">
        <label>{translate("web.newsType", "News Type")}</label>
        <div className="AuctionFilterRadioContainer">
          <NetaqInput
            name={"newscategory"}
            key={"fromEAHS"}
            type={"radio"}
            value={"fromEAHS"}
            label={translate("web.fromEAHS", "from EAHS")}
            onChange={handleChange}
          />
          <NetaqInput
            name={"newscategory"}
            key={"aboutEAHS"}
            type={"radio"}
            value={"aboutEAHS"}
            label={translate("web.aboutEAHS", "about EAHS")}
            onChange={handleChange}
          />

          <NetaqInput
            name={"newscategory"}
            key={"both"}
            type={"radio"}
            value={"both"}
            checked={checker}
            label={translate("web.both", "both")}
            onChange={handleChange}
          />
        </div>
      </div>
      <div className="mb-form-group">
        <label>{translate("web.newsClassification", "News Classification")}</label>
        <div className="AuctionFilterRadioContainer">
          <NetaqInput
            name={"newsClassification"}
            key={"General"}
            type={"radio"}
            value={"General"}
            label={translate("web.general", "General")}
            onChange={handleChange}
          />
          <NetaqInput
            name={"newsClassification"}
            key={"ActivitiesAndEvents"}
            type={"radio"}
            value={"ActivitiesAndEvents"}
            label={translate("web.eventsAndActivities", "Events And Activities")}
            onChange={handleChange}
          />

          <NetaqInput
            name={"newsClassification"}
            key={"both"}
            type={"radio"}
            value={"both"}
            checked={checker}
            label={translate("web.both", "both")}
            onChange={handleChange}
          />
        </div>
      </div>
      <div className="mb-form-group-last">
        <div className="row">
          <div className="col-6">
            <NetaqInput
              name={"DateFrom"}
              key={"DateFrom"}
              type={"date"}
              label={<>
                {translate("web.date", "Date")} {translate("web.from", "From")}
              </>
              }
              onChange={handleChange}
              value={dateStartFrom}
            />
          </div>
          <div className="col-6">
            <NetaqInput
              name={"DateTo"}
              key={"DateTo"}
              type={"date"}
              label={
                <>
                  {translate("web.date", "Date")} {translate("web.to", "To")}
                </>
              }
              onChange={handleChange}
              value={dateStartTo}
              minDate={dateStartFrom}
            />
          </div>
        </div>
      </div>

      <div className={filterButtonsContainer}>
        <div className={filterResetBtn}>
          <NewActionButton
            key={"reset"}
            isButton
            classNames="btn-outline-secondary"

            type={"reset"}
            text={translate('web.reset', 'Reset')}
          />
        </div>
        <div className={filterSubmitBtn}>
          <NewActionButton
            isButton
            classNames="btn-danger"
            text={translate("web.search", "Search")}
            key={"apply"}
            type={"submit"}
          />
        </div>
      </div>
    </form>
  );
};

export default NewsFilter;
